import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RESTServiceV2 } from './rest.service.v2';

@Injectable({
  providedIn: 'root',
})
export class ContractService {
  constructor(private rest: RESTServiceV2) {}

  getContractSignMode(): Observable<any> {
    const resource = `/contracts/user/isConfirming`;
    return this.rest.get(resource);
  }

  getMyContracts(): Observable<any> {
    return this.rest.get('/contracts');
  }
}
